export const fabricRoutes = {
	fabrics: (query: string) => `/product-fabrics/${query ? `?${query}` : ''}`,
	fabric: (id: string) => `/product-fabrics/${id}/`,
	fabricsDelete: '/product-fabrics/bulk_delete/'
} as const
